module.exports = __webpack_public_path__ + "16333da508bd35cb2b151c8eb3c448e5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/fire-hair-s.png
// module id = 2188
// module chunks = 0